'use es6';

import { isContactCreateAttributionReport, isDealCreateAttributionReport, isRevenueAttributionReport } from '../../../lib/report-logic';
export const ATTRIBUTION_UPGRADE_PRODUCT_TYPES = {
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE'
};
export const getAttributionReportUpgradeProduct = report => {
  return isContactCreateAttributionReport(report) ? ATTRIBUTION_UPGRADE_PRODUCT_TYPES.PRO : isDealCreateAttributionReport(report) || isRevenueAttributionReport(report) ? ATTRIBUTION_UPGRADE_PRODUCT_TYPES.ENTERPRISE : null;
};